"use server";

import { teachersService } from "../services/teachersService";
import { extractDomain, extractFranchiseeId } from "../utils/domain";
import { ProcessedTeacher } from "@/src/lib/types/home";

export async function getTeachersAction(franchiseeId?: string | null): Promise<{
  success: boolean;
  data: ProcessedTeacher[];
}> {
  try {
    const domain = await extractDomain();
    const teachers = await teachersService.fetchByDomain(domain, franchiseeId);
    return {
      success: true,
      data: teachers,
    };
  } catch (error) {
    console.error("[getTeachersAction] Error:", error);
    return {
      success: false,
      data: [],
    };
  }
}
